const BASE_API_URL = "https://cms-sea.kkp.go.id";

export default {
    baseApiUrl: BASE_API_URL
}
